export const asAlerts = {
  data: `<svg width="8" height="14" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.666992 0.333984V7.66732H2.66695V13.6673L7.33352 5.66732H4.66691L6.66687 0.333984H0.666992Z" />
  </svg>
  `,
  name: 'alerts',
};
